import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { serializeAxiosError } from 'app/shared/reducers/reducer.utils';

const initialState = {
  loading: false,
  registrationSuccess: false,
  registrationFailure: false,
  errorMessage: null,
  successMessage: null,
  invitedUser: null,
};

export type RegisterState = Readonly<typeof initialState>;

// Actions

export const handleRegister = createAsyncThunk(
  'register/create_account',
  async (data: { login: string; email: string; password: string; langKey?: string; key?: string }) =>
    axios.post<any>(`api/register` + (data?.key ? '?type=invite' : ''), data),
  { serializeError: serializeAxiosError },
);

export const getInvitedUser = createAsyncThunk(
  'register/get_invited_user',
  async (data: { key: string }) => axios.get<any>(`api/activate?type=invite&key=${data?.key}`),
  {
    serializeError: serializeAxiosError,
  },
);

export const RegisterSlice = createSlice({
  name: 'register',
  initialState: initialState as RegisterState,
  reducers: {
    reset() {
      return initialState;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleRegister.pending, state => {
        state.loading = true;
      })
      .addCase(handleRegister.rejected, (state, action) => ({
        ...initialState,
        registrationFailure: true,
        errorMessage: action.error.message,
      }))
      .addCase(handleRegister.fulfilled, () => ({
        ...initialState,
        registrationSuccess: true,
        successMessage: 'register.messages.success',
      }))
      .addCase(getInvitedUser.fulfilled, (state, action) => ({
        ...initialState,
        invitedUser: action.payload.data,
      }));
  },
});

export const { reset } = RegisterSlice.actions;

// Reducer
export default RegisterSlice.reducer;
